// extracted by mini-css-extract-plugin
export default {"tab-item":"styles-module__tab-item___PoYwL","active":"styles-module__active___l3ppB","big_screen":"styles-module__big_screen___JbfYL"};